import { Module, ActionContext } from 'vuex'
import { RootState, IntegrationsState } from './state_models'

export const integrations: Module<IntegrationsState, RootState> = {
  namespaced: true,
  state: { integrations: undefined, locationId: undefined },
  getters: {
    getByLocationId: (
      state: IntegrationsState,
      getters: any,
      rootState: RootState,
      rootGetters: any
    ) => {
      return (locationId: string) =>
        state.locationId === locationId ? state.integrations : {}
    },
  },
  mutations: {
    set: (state: IntegrationsState, payload) => {
      state.locationId = payload.locationId
      state.integrations = payload.integrations
    },
  },
  actions: {
    set(context: ActionContext<IntegrationsState, RootState>, payload) {
      context.commit('set', payload)
    },
  },
}
